import { dateLib } from "@agentcall/core/lib"
import { X } from "lucide-react"
import type { OwnerModels } from "@/api/client/owner"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { OperationRuleDetailBody } from "./OperationRuleDetailBody"

interface OwnerHistoryModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  selectedOperationHistory: OwnerModels.OwnerGet200OwnerOperationRulesItemOperationRuleLogsItem | null
}

export function OwnerHistoryModal({
  open,
  onOpenChange,
  selectedOperationHistory,
}: OwnerHistoryModalProps) {
  const operationRule = selectedOperationHistory

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[800px] max-h-[90vh] overflow-y-auto p-0">
        <div className="p-6">
          <DialogHeader>
            <DialogTitle className="text-[18px] font-semibold">
              運用ルール詳細{operationRule?.deleted ? "（削除時点）" : ""}
            </DialogTitle>
            <DialogDescription className="text-sm text-slate-500">
              更新日時：{operationRule ? dateLib.formatDateTime(operationRule.createdAt) : "-"}
            </DialogDescription>
          </DialogHeader>

          <button
            type="button"
            onClick={() => onOpenChange(false)}
            className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100"
          >
            <X className="h-4 w-4" />
            <span className="sr-only">閉じる</span>
          </button>

          <div className="mt-6">
            <OperationRuleDetailBody operationRule={operationRule} />
          </div>

          {/* ボタン */}
          <div className="flex justify-end gap-3 pt-6 border-t mt-6">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              閉じる
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
